import { Component, OnInit,Pipe, PipeTransform  } from '@angular/core';
import { JwksValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from '../core/auth/auth.config';
import { WorkspaceService } from '../core/services/workspace/workspace.service';
import { Globals } from '../globals/globals';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval, Subscription } from 'rxjs';
import { NotificationService } from '../core/services/notifications/notification.service';
import { EventService } from '../core/services/event.service';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.scss'],
    standalone: false
})
export class PagesComponent implements OnInit{
  isCondensed = false;

  // Read straight off the body class so we stay in sync no matter who flips
  // it (topbar hamburger, sidebar's NavigationEnd-close, the legacy app.js
  // jQuery handler). Re-evaluated on every change-detection cycle, which is
  // good enough — toggles only happen via user actions.
  get mobileMenuOpen(): boolean {
    return document.body.classList.contains('sidebar-enable');
  }

  constructor(public globals: Globals
    , private workspaceService: WorkspaceService
	,private spinner: NgxSpinnerService,
	private notificationService: NotificationService,
	private eventService: EventService) {
  }

  ngOnInit(): void {
    document.body.setAttribute('data-layout', 'vertical');
    // Set sidebar to expanded (large) by default
    document.body.removeAttribute('data-sidebar-size');
    this.isCondensed = false; // Set condensed state to false
	this.getNotificationCount();
	this.globals.spinnerAnimation = true;
	//this.spinner.hide();

	// The '' -> 'newdashboard' redirect is handled at the router level
	// (see pages-routing.module.ts). Doing it again here remounted the
	// dashboard a second time and doubled every dashboard API call.
  }

  getNotificationCount(){
    this.notificationService.geUnreadNotificationCount().subscribe((res) => {
      if (res.flag) {
        this.eventService.setNotificationCountData(res.data)
      }
    });
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    document.body.classList.toggle('sidebar-enable');
    this.isCondensed = !this.isCondensed;
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }
}
